import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowExpand03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M14.648 1.4a1 1 0 0 0 0 2v-2m6.951 1h1a1 1 0 0 0-1-1zm-1 6.952a1 1 0 1 0 2 0h-2m-7.11 1.158-.707-.707zM9.352 22.6a1 1 0 1 0 0-2v2m-6.951-1h-1a1 1 0 0 0 1 1zm1-6.952a1 1 0 1 0-2 0h2M14.648 2.4v1h6.951v-2h-6.951zm6.951 0h-1v6.952h2V2.4zm0 0-.707-.707-8.11 8.11.707.707.707.707 8.11-8.11zM9.352 21.6v-1H2.401v2h6.951zm-6.951 0h1v-6.952h-2V21.6zm0 0 .707.707 11.088-11.09-.707-.707-.707-.707-11.089 11.09z"
    />
  </svg>
);
export default SvgArrowExpand03;
